import * as React from "react";

const Store = React.createContext(null);

Store.displayName = 'Store';

export const StoreProvider = ({ children, initialState, reducer }) => {


  const [globalState, dispatch] = React.useReducer(reducer, initialState);


  return (<Store.Provider value={[globalState, dispatch]}>{children}</Store.Provider>);
}


export const useStore = () => {

  const [state, dispatch] = React.useContext(Store);

  const tabData = state && state.tabData ? state.tabData : {};
  const updatedValues = state && state.updatedValues ? state.updatedValues : {};
  const skills = state && state.skills ? state.skills : []
  const sponsors = state && state.sponsors ? state.sponsors : []
  const settings = state && state.settings ? state.settings : {}
  const microSites = state && state.microSites ? state.microSites : {}
  const microSiteActions = state && state.microSiteActions ? state.microSiteActions : {}
  const pendingFullMembersCount = state && state.pendingFullMembersCount ? state.pendingFullMembersCount : ""
  const pendingHubMembersCount = state && state.pendingHubMembersCount ? state.pendingHubMembersCount : ""
  const deleteReviewsFullCount = state && state.deleteReviewsFullCount ? state.deleteReviewsFullCount : ""
  const deleteReviewsHubCount = state && state.deleteReviewsHubCount ? state.deleteReviewsHubCount : ""
  const orgImageUrl= state && state.orgImageUrl ? state?.orgImageUrl:''
  const tabInterestName = state && state?.tabInterestName || ''




  return {
    dispatch,
    tabData,
    updatedValues,
    skills,
    sponsors,
    settings,
    microSites,
    microSiteActions,
    pendingFullMembersCount,
    pendingHubMembersCount,
    deleteReviewsFullCount,
    deleteReviewsHubCount,
    orgImageUrl,
    tabInterestName
  }

}
